export default __webpack_public_path__ + "static/media/help-circle.648affb2.svg";